///
/// EarthBrowser
///
/// Created by Matt Giger on 9/15/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Toast shown when a hurricane sync carries new advisories. Each storm
/// is a deep link: clicking dispatches the same selectId action as global
/// search, which flies the camera to the storm, opens its info panel and
/// pushes storm-<id> onto the URL for back/forward + sharing.
///

import { showEntityToast } from "@/components/ui/entity-toast"
import { sendDatasetAction } from "@/redux/earthBrowserSlice"
import { appStore } from "@/redux/store"
import { Wind } from "lucide-react"

export interface StormAdvisoryUpdate {
	/** Storm id (hurricanes table primary key, used by selectId) */
	id: string
	/** Display label, e.g. "Hurricane Melissa · Advisory 12" */
	label: string
}

export function showStormAdvisoryToast(updates: StormAdvisoryUpdate[]): void {
	showEntityToast({
		title: updates.length === 1 ? "New storm advisory" : "New storm advisories",
		icon: Wind,
		iconClass: "bg-sky-500/15 text-sky-400",
		variant: "info",
		entries: updates.map(update => ({
			id: update.id,
			label: update.label,
			onSelect: () => {
				appStore.dispatch(sendDatasetAction({
					type: "hurricane",
					action: "selectId",
					id: update.id,
				}))
			},
		})),
	})
}
